export const changeHotelsFilter = (content) => ({
  type: 'changeHotelsFilter',
  payload: content,
});

export const changeStarsFilter = (content) => ({
  type: 'changeStarsFilter',
  payload: content,
});

export const changeStarsFilterHover = (content) => ({
  type: 'changeStarsFilterHover',
  payload: content,
});

export const changeRatingFilter = (content) => ({
  type: 'changeRatingFilter',
  payload: content,
});

export const changeMealsFilter = (content) => ({
  type: 'changeMealsFilter',
  payload: content,
});

export const changeBeachLineFilter = (content) => ({
  type: 'changeBeachLineFilter',
  payload: content,
});

export const changeBeachTypesFilter = (content) => ({
  type: 'changeBeachTypesFilter',
  payload: content,
});

export const changeHotelTypeFilter = (content) => ({
  type: 'changeHotelTypeFilter',
  payload: content,
});

export const changeOperatorsFilter = (content) => ({
  type: 'changeOperatorsFilter',
  payload: content,
});

export const changeHotelServicesFilter = (content) => ({
  type: 'changeHotelServicesFilter',
  payload: content,
});

export const changeOnlyCharter = (content) => ({
  type: 'changeOnlyCharter',
  payload: content,
});

export const changeDirectFlight = (content) => ({
  type: 'changeDirectFlight',
  payload: content,
});

export const changeMaxPrice = (content) => ({
  type: 'changeMaxPrice',
  payload: content,
});

export const changeMinPrice = (content) => ({
  type: 'changeMinPrice',
  payload: content,
});

export const changeMaxPriceFilter = (content) => ({
  type: 'changeMaxPriceFilter',
  payload: content,
});

export const changeMinPriceFilter = (content) => ({
  type: 'changeMinPriceFilter',
  payload: content,
});

export const changeCurrency = (content) => ({
  type: 'changeCurrency',
  payload: content,
});

export const changeRegionsOptions = (content) => ({
  type: 'changeRegionsOptions',
  payload: content,
});

export const changeIsAllRegionsFilterTab = (content) => ({
  type: 'changeIsAllRegionsFilterTab',
  payload: content,
});

export const changeIsAllOperatorsTab = (content) => ({
  type: 'changeIsAllOperatorsTab',
  payload: content,
});

export const changeSelectedHotels = (content) => ({
  type: 'changeSelectedHotels',
  payload: content,
});
